import React, { Component } from 'react';
import { Button } from '@material-ui/core';

class PaygateLaunch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            status: "",
            warning: '',
            mainHeadText: 'Thank You!',
            confirmed: false,
            missingQparms: false,
            launch_url: ''
        }
    }
    
    componentDidMount() {
        if (!this.props.qparms.token||!this.props.qparms.entry||!this.props.qparms.item_name||!this.props.qparms.amount||!this.props.qparms.email_address||!this.props.qparms.receiver){
            this.setState({missingQparms:true});
        }

        let redirect_url = "https://www.payfast.co.za/eng/process?cmd=_paynow&receiver=" + this.props.qparms.receiver + "&item_name=" + this.props.qparms.item_name + "&amount=" + this.props.qparms.amount + "&email_address=" + this.props.qparms.email_address + "&m_payment_id=" + this.props.qparms.entry + "&return_url=https://prime-entry.web.app?op=S" + this.props.qparms.entry + "~" + this.props.qparms.token + "&cancel_url=https://prime-entry.web.app?op=F" + this.props.qparms.entry + "~" + this.props.qparms.token

        // console.log('redirect_url :>> ', encodeURI(redirect_url));

        this.setState({launch_url: encodeURI(redirect_url)});
        // window.location.replace(encodeURI(redirect_url));

    }

    render() {

        return (
            <div style={{maxWidth:900}}>

                {this.state.missingQparms&&
                <div>
                    <h3>Technical Error</h3>
                    Unfortunately a technical error was encountered when we tried to process your application.<br/>
                    If this problem persists, please contact us.
                </div>}
                
                {!this.state.missingQparms&&
                <div>
                    <h3>{this.state.mainHeadText}</h3>
                    We've received your application / registration form. <br/>
                    Next we need to process your payment... 

                    <br/><br/>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={()=> window.parent.location.href = this.state.launch_url}
                    >
                        Proceed to Payment Portal
                    </Button>

                    <span id="StatusBar" className="StatusBar">
                        {/* {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp; */}
                        {this.state.status}
                    </span>
                    <span className='warningMessage'>{this.state.warning}</span>
                    <br/>
                </div>}

            </div>
        );
    }
    
}

export default PaygateLaunch;